import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { RedirectionUrls } from 'src/app/shared/global/redirectionsUrls';
import { UserService } from '../../services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {

  redirectionUrls = RedirectionUrls.redirectRoot

  constructor(private router: Router, private userService: UserService) { }

  canActivate(
    route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const expectedRole = route.data.expectedRole;
    const userType = this.userService.userType;
    if (userType !== null && [...expectedRole].includes(userType)) {
      return true;
    }

    const rediectionUrl =
      RedirectionUrls.redirectRoot[userType] ?
      RedirectionUrls.redirectRoot[userType].url :
      'auth/login';

    this.router.navigate([rediectionUrl]);
    return true;
  }
}
